import { useEffect, useState } from "react";
import httpRequest from "../../../utils/HttpRequest";
import { PageOption } from "../pagination/PageOption";
import { log } from "@antv/g2plot/lib/utils";


export interface ITablePagenationParma<T> {
    lineNum: number,
    pageNo: number,
    pageCount: number,
    records: number,
    data: T[],
    update: (option?: PageOption) => void,
    setLineNum: (val: number) => void
}

export default function useTableDataWithPagination<T>(
    url: string,
    requestData: object,
    defaultValue?: T[],
    stopUpdate?: (requestData: object) => boolean,
): ITablePagenationParma<T> {
    const [lineNum, setLineNum] = useState(5);
    const [pageNo, setPageNo] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [records, setRecords] = useState(0);
    const [data, setData] = useState<T[]>();
    const [redOperate, setoperate] = useState<number | undefined>()

    function update(option?: PageOption) {
        
      
        if (!option) option = PageOption.first;
        // if (stopUpdate && stopUpdate(requestData)) return;
        httpRequest(url, Object.assign({}, requestData, {
            pagesize: lineNum,
            operate: PageOption[option],
            pagenum: pageNo
        }))
            .then(res => {
                if (res.data.errno !== 0)
                    throw res.data.errmsg;
                else
                    return res.data;
            })
            .then(data => {
                setData(data.data);
                setPageNo(data.extendattr.curpage);
                setPageCount(data.extendattr.pagecount);
                setRecords(data.extendattr.records);
                
            })
            .catch(console.error);
    }

    useEffect(() => {
        update(PageOption.first);
    }, [lineNum]); // eslint-disable-line


    return {
        lineNum: lineNum,
        pageNo: pageNo,
        pageCount: pageCount,
        records: records,
        data: data ? data : [],
        update: update,
        setLineNum: setLineNum,
    };
}